import React from "react"

const MessageOnPhone = ({ width="120", height="120", viewBox="0 0 120 120" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M77.813 65.626c-1.036 0-1.876.84-1.876 1.875v33.749h-63.75v-82.5h20.626a1.875 1.875 0 000-3.75H12.186v-1.875c0-5.17 4.206-9.375 9.376-9.375h45a1.875 1.875 0 000-3.75h-45C14.325 0 8.438 5.888 8.438 13.125v93.75c0 7.237 5.887 13.125 13.124 13.125h45c7.237 0 13.126-5.888 13.126-13.125V67.501c0-1.036-.84-1.875-1.876-1.875zm-11.25 50.624h-45c-5.17 0-9.375-4.206-9.375-9.375V105h63.75v1.875c0 5.169-4.206 9.375-9.376 9.375z"
        fill="#fff"
      />
      <path
        d="M47.813 108.75h-7.5a1.875 1.875 0 000 3.75h7.5a1.875 1.875 0 000-3.75zM31.486 8.048c-.35.35-.549.835-.549 1.327s.2.977.549 1.327c.35.349.832.548 1.326.548.495 0 .978-.2 1.327-.548.35-.35.548-.832.548-1.327s-.199-.977-.548-1.327a1.887 1.887 0 00-1.327-.548c-.494 0-.977.2-1.326.548zM49.688 31.875h11.25a1.875 1.875 0 000-3.75h-11.25a1.875 1.875 0 000 3.75zM98.438 28.125h-30a1.875 1.875 0 000 3.75h30a1.875 1.875 0 000-3.75zM98.438 37.5h-11.25a1.875 1.875 0 000 3.75h11.25a1.875 1.875 0 000-3.75zM49.688 41.25h30a1.875 1.875 0 000-3.75h-30a1.875 1.875 0 000 3.75zM98.438 18.75h-48.75a1.875 1.875 0 000 3.75h48.75a1.875 1.875 0 000-3.75zM98.438 46.875h-48.75a1.875 1.875 0 000 3.75h48.75a1.875 1.875 0 000-3.75z"
        fill="#fff"
      />
      <path
        d="M98.438 7.5h-48.75c-7.238 0-13.126 5.888-13.126 13.125V48.75c0 6.6 4.898 12.079 11.25 12.991v6.857c0 1.523.91 2.882 2.315 3.465a3.74 3.74 0 004.087-.813l9.375-9.375h34.849c7.237 0 13.124-5.888 13.124-13.125V20.625c0-7.237-5.887-13.125-13.124-13.125zm9.374 41.25c0 5.17-4.205 9.375-9.374 9.375H62.812c-.497 0-.974.198-1.325.55l-9.925 9.922V60c0-1.035-.839-1.875-1.874-1.875-5.17 0-9.376-4.206-9.376-9.375V20.625c0-5.17 4.206-9.375 9.376-9.375h48.75c5.169 0 9.374 4.206 9.374 9.375V48.75z"
        fill="#fff"
      />
    </svg>
  )
}

export default MessageOnPhone